import React from 'react';
import { Tag, Tooltip } from 'antd';
import { APP_ENV, ENV_LABEL, SUPABASE_URL } from '../env';

function host(url: string): string {
  try {
    return new URL(url).host;
  } catch {
    return url;
  }
}

/** Always visible, so the owner knows which database the page edits. */
export const EnvBadge: React.FC = () => (
  <Tooltip title={SUPABASE_URL ? `Database: ${host(SUPABASE_URL)}` : 'No database configured'}>
    <Tag
      color={APP_ENV === 'production' ? 'red' : APP_ENV === 'staging' ? 'orange' : 'default'}
      style={{ marginInlineEnd: 0, fontWeight: 600 }}
      data-testid="env-badge"
    >
      {ENV_LABEL[APP_ENV]}
    </Tag>
  </Tooltip>
);
